module.exports = __webpack_public_path__ + "static/media/handbok-drawer-mf-ikon@3x.a4077cbb.png";